module.exports = __webpack_public_path__ + "img/wyb.41a74d6.png";